/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { CandidatsCards } from 'components/candidats-cards'

const ARTICLE_ID = '701915679047'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      {/* <Cover /> */}

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <div className='top-line'>Communes genevoises</div>
            <h1>Voici les 45 maires pour l’année 2023-24</h1>
            <h2>
              Depuis le 1er juin, vingt et une mairies ont un nouveau magistrat
              à leur tête.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Caroline Zumbach</div>
            <div className='ta updated'>Mis à jour le 5 juin 2023</div>
          </div>
          <div className='ta text'>
            <p>
              Dix-sept femmes et vingt-huit hommes dirigeront les communes
              genevoises pour cette quatrième année de la législature. Dans
              vingt et une d’entre elles, un nouveau magistrat devient maire.
              Dans les vingt-quatre autres (qui comptent moins de 3000
              habitants), l’Exécutif reste inchangé jusqu’aux prochaines
              élections. C’est le cas d’Aire-la-Ville, Anières, Avully, Avusy,
              Bardonnex, Cartigny, Céligny, Chancy, Choulex, Collex-Bossy,
              Corsier, Dardagny, Genthod, Gy, Hermance, Jussy, Laconnex,
              Meinier, Presinge, Puplinge, Russin, Soral, Troinex et Vandœuvres.
            </p>
            <p>
              Au total, vingt-quatre maires sont désormais issus de formations
              communales. Le PLR, lui, compte neuf magistrats à la tête d’une
              mairie. Il est suivi par Le Centre, qui en dénombre six. Le Parti
              socialiste et les Verts en ont trois chacun.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui container'>
          <CandidatsCards />
        </div>
      </div>

      <Footer
        mailTo='interactif@tamedia.ch'
        locale='fr'
        hidePortfolioTeaser
        articleId={ARTICLE_ID}
        credits={[['Texte', 'Caroline Zumbach']]}
      />
    </div>
  )
}
